module.exports = __webpack_public_path__ + "img/ic_services_touristicinfo.95706318.svg";